import { format } from 'date-fns';
import { Dispatch } from 'react';
import styled, { css } from 'styled-components';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { FontWeight, ZIndex } from '../../../common/styles/constants';
import { onMobile } from '../../../common/styles/onMobile';

interface Props {
  date: Date;
  past?: boolean;
  selected?: boolean;
  unavailable?: boolean;
  onSelect?: Dispatch<Date>;
}

export const CalendarDate = ({
  date,
  onSelect,
  past = false,
  selected = false,
  unavailable = false,
}: Props) => {
  const handleClick = () => {
    if (!past && !unavailable) {
      onSelect?.(date);
    }
  };

  return (
    <Outer onClick={handleClick} data-testid="CalendarDate">
      <DateView past={past} selected={selected} unavailable={unavailable}>
        {format(date, 'd')}
      </DateView>
    </Outer>
  );
};

const Outer = styled.div`
  flex: 0 0 22%;
  margin-inline-end: -4%;
  margin-inline-start: -4%;
`;

const DateView = styled.div<{ past: boolean; selected: boolean; unavailable: boolean }>`
  border-radius: 14px;
  color: ${ThemeColours.black};
  cursor: pointer;
  font-size: 14px;
  font-weight: ${FontWeight.SEMI_BOLD};
  height: 28px;
  line-height: 28px;
  text-align: center;
  user-select: none;
  ${onMobile} {
    font-size: 18px;
    font-weight: ${FontWeight.REGULAR};
    height: 32px;
    line-height: 32px;
  }
  @include transition(background-color 0.2s, color 0.2s, transform 0.2s);

  ${it =>
    it.selected &&
    css`
      background-color: ${ThemeColours.primary50};
      color: ${ThemeColours.black};
    `};

  ${it =>
    it.past &&
    css`
      color: ${ThemeColours.mono300};
    `};

  ${it =>
    !it.unavailable &&
    !it.past &&
    css`
      &:hover {
        position: relative;
        z-index: ${ZIndex.UNDERLAY};
        background-color: ${ThemeColours.buttonPrimaryFill};
        color: ${ThemeColours.buttonPrimaryText};
      }

      $:active {
        background-color: ${ThemeColours.primary600};
        transform: scale(0.92);
      }
    `};

  ${it =>
    it.unavailable &&
    !it.past &&
    css`
      color: ${ThemeColours.mono500};
    `};

  width: 100%;
  ${it =>
    (it.past || it.unavailable) &&
    css`
      cursor: not-allowed;
    `};
`;
